import { useEffect } from 'react';
import main from '../../main';
import { getLandingPageNumber } from '../../utils/landingPage';
import { copyToClipboard, parseLocationParams } from '../../utils/utils';

interface Props {
  // 标题
  title?: string;
  // 标题前面按钮
  iconShow?: boolean;
  // 关闭弹窗x号
  cancelShow?: boolean;
  url?: string;
  // 弹窗内容
  content?: string;
  // 提示内容
  tips?: string;
  // 按钮文案
  confirmText?: string;
  contentTips?: string;
  onClose: (v?: boolean) => void;
}

export default function NotWxPageDialog({
  title = '温馨提示',
  iconShow = true,
  cancelShow = false,
  content = '',
  tips = '',
  confirmText = '确认',
  url,
  contentTips,
  onClose,
}: Props) {
  useEffect(() => {
    window.document.body.style.overflow = 'hidden';
  }, []);

  function handleCopyHost() {
    let landingCode = sessionStorage.getItem('landingCode') ?? '';
    let param = parseLocationParams(window.location.search);
    let _url = url ? url : window.location.href;
    let shopNum = landingCode ? getLandingPageNumber(main.shopId) : '';
    if (!param?.sn && !!landingCode) {
      _url = window.location.href + `&sn=${shopNum}`;
    }
    copyToClipboard(_url);
  }
  function handleClose() {
    window.document.body.style.overflow = '';
    handleCopyHost();
    // let uri = window.location.href;
    // let redirect_uri = encodeURIComponent(uri);
    // const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${main.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
    // document.location.replace(authUrl);
    // if(window.location.search.includes('code'))
    onClose();
  }
  return (
    <div className="wrong-dialog d-flex-r ai-center jc-center">
      <div className="wrong-mask" />
      <div className="bw-100 wrong-center" onClick={() => {}}>
        <div className="wrong-title-block border-bottom pb-20">
          <div className="flex-1 d-flex-r ai-center jc-between pt-20 pr-20">
            <div className="flex-1 d-flex-r ai-center jc-center">
              <div className="w-30 mr-10">
                {iconShow && <img className="w-30" src="/pic/icon_close_dialog.png" alt="" />}
              </div>

              <span className="font-size-16 font-widget-600">{title}</span>
            </div>
            <div className="w-16">
              {cancelShow && <img className="w-16" src="/pic/icon_close_black.png" alt="" onClick={() => onClose()} />}
            </div>
          </div>
        </div>
        <div className="wrong-content d-flex-c ai-center jc-center">
          <div className="flex-1 bw-100 d-flex-c jc-center border-bottom p-10">
            {contentTips && <span className="mb-10">{contentTips}</span>}
            <div className="no-select bw-100 mb-10 p-10 border border-radius-8 font-size-14 bg-gray line-height-24 text-color-3 word-wrap">
              {content}
            </div>
            {tips && <div className="mt-10 mb-10 font-size-12 text-color-red">{tips}</div>}
          </div>
          <div className="bw-100">
            <div
              className="m-10 pt-10 pb-10 border-top d-flex-r ai-center jc-center bg-p m-10 border-radius-8 text-color-white font-size-14"
              onClick={handleClose}
            >
              {confirmText}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
